import { instanceToPlain } from "class-transformer";
import CommentRequestResource from "common/resources/Project/Config/Forum/Comment/CommentRequestResource";
import CommentResponseResource from "common/resources/Project/Config/Forum/Comment/CommentResponseResource";
import BaseCommentApi from "./BaseCommentApi";

export default class CommentApi extends BaseCommentApi {
	/**
	 * @description Get all comments for a post
	 */
	public async getAll(projectId: string, postId: string): Promise<CommentResponseResource[]> {
		return this.getRequest<CommentResponseResource[]>(this.getBaseUrl({ projectId, postId })).then((response) => CommentResponseResource.hydrateArray(response));
	}

	/**
	 * @description Count comments for a post
	 */
	public async count(projectId: string, postId: string): Promise<{ count: number }> {
		return this.getRequest<{ count: number }>(`${this.getBaseUrl({ projectId, postId })}/count`);
	}

	/**
	 * @description Create a comment on a post
	 */
	public async create(projectId: string, postId: string, request: CommentRequestResource): Promise<CommentResponseResource> {
		return this.postRequest<CommentResponseResource>(this.getBaseUrl({ projectId, postId }), instanceToPlain(request)).then((response) =>
			CommentResponseResource.hydrate(response),
		);
	}
}
